import * as React from 'react';
import equal from 'fast-deep-equal/react';
import { useDispatch } from 'react-redux';
import styles from './ChooseCouponPopup.scss';
import { t } from '~/utils/localization';
import Coupon, { CouponSize } from '~/components/Coupon/Coupon';
import PriceWrapper, { PRICE_WRAPPER_SIZE } from '~/components/PriceWrapper/PriceWrapper';
import { isEnabledCouponFromBundle } from '~/utils/coupons';
import classNames from 'classnames';
import dwhExport from '~/api/dwhExport';
import { DWH_EVENTS } from '~/const';
import { Popup, PopupBody, PopupFooter, PopupHeader } from '~/components/Popup/Popup';
import Button from '~/components/Button/Button';
import { PopupManagerContext } from '~/Contexts/PopupManagerContext';
import { RootState, useAppSelector } from '~/Store';
import { appActions } from '~/Store/appSlice';
import { POPUPS_NAME } from '~/components/PopupManager';

const stateSelector = (state: RootState) => {
    return {
        coupons: state.account.coupons,
        activeCouponId: state.account.activeCouponId,
    };
};

const ChooseCouponPopup = (): any => {
    const { coupons, activeCouponId } = useAppSelector(stateSelector, equal);
    const { popup } = React.useContext(PopupManagerContext);

    const dispatch = useDispatch();
    const filteredCoupons = coupons.filter((coupon: ICoupon) => !coupon.isDisabled && popup.data?.bundle && isEnabledCouponFromBundle(coupon, popup.data?.bundle));

    const close = () => {
        dispatch(appActions.changeVisibilityPopup({ name: POPUPS_NAME.CHOOSE_COUPON_POPUP }));
    };

    const classesChooseCouponPopup = classNames(styles.chooseCouponPopup);

    const classesItems = classNames(styles.items);

    return (
        <Popup onClose={close} closeIconClassName={'armory__auto--popup_close'} className={classesChooseCouponPopup} outsideClick={true}>
            <PopupHeader title={t('Доступные купоны')} className={styles.popupHeader} />
            <PopupBody className={classesItems}>
                {filteredCoupons.map((coupon: ICoupon) => {
                    return (
                        <div className={styles.item} key={coupon.id}>
                            <Coupon
                                coupon={coupon}
                                isActive={coupon.id === activeCouponId}
                                size={CouponSize.BIG}
                                onClick={() => {
                                    dwhExport.send(DWH_EVENTS.APPLY_COUPON, {
                                        bundle_id: popup.data.bundle.id,
                                        coupon_id: coupon.id,
                                    });
                                    popup.data.onClick(coupon.id);
                                }}
                            />
                            <div className={styles.itemTextContent}>{t('Цена с купоном')}</div>
                            <div className={styles.itemContent}>
                                <PriceWrapper
                                    bundle={popup.data.bundle}
                                    coupon={coupon}
                                    size={PRICE_WRAPPER_SIZE.BIG}
                                    isActiveCoupon
                                    withoutAnimation
                                    hiddenPriceWithoutDiscount
                                    priceClassName={styles.price}
                                />
                            </div>
                        </div>
                    );
                })}
            </PopupBody>
            <PopupFooter className={styles.footer}>
                <Button label={t('Закрыть')} onClick={close} />
            </PopupFooter>
        </Popup>
    );
};

export default ChooseCouponPopup;
